export default {
  data() {
    return {
      currentPosition: undefined,
    };
  },
  computed: {
    pointsOfInterestTypes() {
      return [
        'pickupPoint',
        'passthroughPoint',
      ];
    },
  },
  methods: {
    getPosition(options) {
      return new Promise(((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      }));
    },
    async refresh() {
      if (navigator.geolocation) {
        this.currentPosition = await this.getPosition();
        this.$emit('location.changed', this.currentPosition);
        this.$log.debug('Location changed', this.currentPosition);
      } else {
        this.$log.error('Geolocation is not supported by this browser.');
      }
    },
  },
};
